import { setMilliseconds, setSeconds, subDays } from 'date-fns';

// Zero out seconds and milliseconds to stabilize the date value and prevent unnecessary
// re-renders/API calls. Without this, each call would generate a slightly different
// timestamp, causing React to think the filter has changed.
export const getThirtyDaysAgo = () =>
    setMilliseconds(setSeconds(subDays(new Date(), 30), 0), 0);
